// Vendor Libs
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

// Components
import BulkMapping from './bulk-mapping';
import CreateShellButtons from './create-shell-buttons';
import Error from '../core/error';
import Loading from '../core/loading';
import MappingDetail from './mapping-detail';
import Permissions from '../core/permissions';
import ShellForm from './shell-form';

// Containers
import Mapping from '../../containers/mapping';
import withForm from '../../containers/with-form';
import withPermissions from '../../containers/with-permissions';

// Styles
import './create-shell.scss';

const formName = 'createShell';

function CreateShell({className, formData, setFieldValue, setFormSubmitted, hasAccessByType}) {
    const getClass = () =>
        classnames(
            {
                'create-shell': true,
            },
            className
        );

    const renderCreateShellButtons = (mapping) => {
        const {fetching} = mapping;

        return !fetching ? (
            <div className="create-shell--bottom-buttons">
                <CreateShellButtons {...mapping} hasAccessByType={hasAccessByType} />
            </div>
        ) : null;
    };

    const renderShellForm = (mapping) => {
        const {
            bulkMapping,
            episodeOnly,
            error,
            fetched,
            fetching,
            massShell,
            massShellActive,
            mediaItemDetailFetching,
            routerParams: {guid},
            showMessage,
        } = mapping;

        return !error && !fetched && (!fetching || massShellActive) && guid && !showMessage ? (
            <Permissions
                accessRequirement="write"
                lockAccess={true}
                notAuthorizedMessage={true}
                recordId={guid}
                requiresServiceAccess={true}
                serviceKey="mediaItems"
            >
                <ShellForm
                    {...{
                        bulkMapping,
                        episodeOnly,
                        formData,
                        formName,
                        massShell,
                        massShellActive,
                        searchFetching: mediaItemDetailFetching,
                        setFieldValue,
                        setFormSubmitted,
                    }}
                />
                {renderCreateShellButtons(mapping)}
            </Permissions>
        ) : null;
    };

    const renderContent = (mapping) => {
        const {showBulkMapping} = mapping;

        return showBulkMapping ? (
            <BulkMapping {...mapping} />
        ) : (
            <>
                <MappingDetail {...mapping} hasAccessByType={hasAccessByType} />
                {renderShellForm(mapping)}
            </>
        );
    };

    return (
        <Mapping resetOnUnmount={true}>
            {(mapping) => {
                const {
                    cancelMapping,
                    error,
                    fetching,
                    routerParams: {guid},
                } = mapping;

                return guid ? (
                    <div className={getClass()}>
                        <Error error={error} onReset={cancelMapping} />
                        {renderContent(mapping)}
                        <Loading loading={fetching} />
                    </div>
                ) : (
                    <Error error="Select a media item." />
                );
            }}
        </Mapping>
    );
}

CreateShell.propTypes = {
    className: PropTypes.string,
    formData: PropTypes.object.isRequired,
    hasAccessByType: PropTypes.func.isRequired,
    setFieldValue: PropTypes.func,
    setFormSubmitted: PropTypes.func.isRequired,
};

export default withPermissions(withForm(CreateShell, formName));
